import { Box } from '@chakra-ui/core'
import { TaskInput } from 'components/TasksV2/UI/TaskInput'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import useLocaleText from 'components/useLocaleText'
import { Subtask } from 'components/TasksV2/TaskCreation/FormStepContext'
import { useTranslateDefaultTitle } from 'components/TasksV2/hooks/useTranslateDefaultTitle'
import { useBuilderWidget } from 'components/TasksV2/TaskCreation/contexts/BuilderWidgetContext'
import { useCreationText } from 'components/TasksV2/TaskCreation/hooks/useCreationText'

interface Props {
  inputElement?: React.ReactNode
  questionName: string
  field: Subtask
  placeholder?: string
}
export const ImageQeustion: React.FC<Props> = ({ questionName, field, inputElement, placeholder, ...props }) => {
  const { control } = useFormContext()
  const validationMessage = useLocaleText('t_img_st_error')
  const builder = useBuilderWidget()
  const creationText = useCreationText()
  const t_pls_add_picture = useLocaleText('t_pls_add_picture')
  const translatedTitle = useTranslateDefaultTitle(field.title)

  return (
    <Box my={builder ? '0' : '15px'}>
      {builder && (
        <label className="creation-field-label" htmlFor={`${questionName}-input`}>
          {creationText.subtaskTitle} <span>*</span>
        </label>
      )}
      <Controller
        as={TaskInput}
        name={questionName}
        id={builder ? `${questionName}-input` : undefined}
        control={control}
        placeholder={placeholder ?? t_pls_add_picture}
        rules={{
          required: validationMessage,
          validate: (value) => {
            return value.trim() !== '' || validationMessage
          },
        }}
        key={questionName}
        boxShadow="none"
        borderRadius="10px"
        border="none"
        defaultValue={translatedTitle}
        inputElement={inputElement}
        {...props}
      />
    </Box>
  )
}
